export const smsCodeCookie = 'smsnotification';
export const smsServicePhoneNumber = 'smsphonenumber';
export const smsServiceMode = 'smsmode';

export const emailCodeCookie = 'emailnotification';
export const emailServiceAddress = 'emailAddress';
export const emailServiceMode = 'emailmode';
